import React, { useLayoutEffect, useRef } from 'react'
import bwipjs from 'bwip-js'

export enum BarcodeFormats {
    CODE128 = 'code128',
    PDF417 = 'pdf417',
    QRCODE = 'qrcode'
}

interface BarcodeProps {
    format: "code128" | "pdf417" | "qrcode"
    value: string | undefined
    includeText: boolean
}

function renderCode(format: string, value: string | undefined, includeText: boolean): HTMLSpanElement {
    const svg = bwipjs.toSVG({
        bcid: format,
        text: value ?? '',
        includetext: includeText
    })

    const [, width, height] = /viewBox="0 0 (\d+) (\d+)"/.exec(svg) || ['', '', '']
    const span = document.createElement('span')
    span.style.display = 'inline-block'
    span.style.width = width + 'px'
    span.style.height = height + 'px'
    span.innerHTML = svg

    return span
}

export default function Barcode({ format, value, includeText }: BarcodeProps) {
    const myRef = useRef(null)

    useLayoutEffect(() => {
        const code = renderCode(format, value, includeText)
        if (myRef.current) {
            const outputDiv = myRef.current as HTMLDivElement
            outputDiv.replaceChildren(code)
        }
    }, [format, value, includeText])

    return (
        <div ref={myRef} />
    )
}
